module.exports = __webpack_public_path__ + "img/picture_viptc.c6a91761.png";